exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".UnderlineSelector-69846228{display:inline-block}.UnderlineSelector-69846228 a.option-1caafdb1,.UnderlineSelector-69846228 a.option-1caafdb1:hover,.UnderlineSelector-69846228 a.option-1caafdb1:visited{color:inherit;text-decoration:none}.option-1caafdb1{padding:0px 2px;margin:0px 2px;cursor:pointer}.option-1caafdb1:hover{border-bottom:1px solid}.selected-02f2eb14{border-bottom:1px solid}\n", ""]);

// Exports
exports.locals = {
	"UnderlineSelector": "UnderlineSelector-69846228",
	"option": "option-1caafdb1",
	"selected": "selected-02f2eb14"
};